import { useMutation } from '@tanstack/react-query'

import { StoriesService } from '../lib/stories.service'

export const useViewStory = () => {
  return useMutation({
    mutationFn: (id: string) => {
      return StoriesService.viewStory(id)
    }
  })
}
